var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var Action;
(function (Action) {
    Action["Accept"] = "ACCEPT";
    Action["Reject"] = "REJECT";
    Action["Undecided"] = "UNDECIDED";
})(Action || (Action = {}));
var Kind;
(function (Kind) {
    Kind["Conflict"] = "CONFLICT";
    Kind["Confirmed"] = "CONFIRMED";
    Kind["Unconfirmed"] = "UNCONFIRMED";
    Kind["Placeholder"] = "PLACEHOLDER";
})(Kind || (Kind = {}));
var ProfileAgentController = (function () {
    function ProfileAgentController(RepresentationService, UserService) {
        this.choices = [];
        this.$representationService = RepresentationService;
        this.$userService = UserService;
    }
    ProfileAgentController.prototype.$onInit = function () {
        var _this = this;
        this.setCurrentWork(this.fetch().then(function () {
            var user = _this.$userService.getUser();
            _this.recalculateChoices(user);
        }));
    };
    ProfileAgentController.prototype.setCurrentWork = function (promise) {
        this.promise = promise;
    };
    ProfileAgentController.prototype.isUnconfirmed = function (representation) {
        return !representation.confirmed;
    };
    ProfileAgentController.prototype.recalculateChoices = function (user) {
        var conflicts = user.tasks['player:representation-conflicts'] || [];
        var unconfirmed = user.tasks['player:unconfirmed-representations'] || [];
        this.choices = [];
        var confirmed = this.representations.filter(function (item) { return !!item.confirmed; });
        var affectedRegions = __spreadArray(__spreadArray([], unconfirmed.map(function (item) { return _.pick(item, ['region', 'country']); }), true), conflicts.map(function (item) { return item.filter; }), true);
        var _loop_1 = function (region) {
            var options = [];
            conflicts.filter(isConflictInRegionStrict(region)).forEach(function (conflict) {
                options.push({
                    kind: Kind.Conflict,
                    action: Action.Undecided,
                    conflict: conflict,
                });
            });
            unconfirmed.filter(isRepresentationInRegionStrict(region)).forEach(function (representation) {
                options.push({
                    kind: Kind.Unconfirmed,
                    action: Action.Undecided,
                    representations: [representation],
                });
            });
            if (confirmed.filter(isRepresentationInRegionRelaxed(region)).length) {
                options.push({
                    kind: Kind.Confirmed,
                    action: Action.Undecided,
                    representations: confirmed.filter(isRepresentationInRegionRelaxed(region)),
                });
            }
            if (options.length === 1 && _.has(options[0], 'representations.0.type') === false) {
                options.push({
                    kind: Kind.Placeholder,
                    action: Action.Undecided,
                });
            }
            this_1.choices.push({
                filter: region,
                options: options,
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = _.uniqWith(affectedRegions, _.isEqual); _i < _a.length; _i++) {
            var region = _a[_i];
            _loop_1(region);
        }
        this.choices = _.sortBy(this.choices, function (item) { return "".concat(item.filter.region || '', ":").concat(item.filter.country || ''); });
    };
    ProfileAgentController.prototype.toggle = function (choice, option) {
        switch (option.action) {
            case Action.Undecided:
            case Action.Reject:
                this.enable(choice, option);
                choice.options
                    .filter(function (item) { return item !== option; })
                    .forEach(function (option) { return (option.action = Action.Reject); });
                break;
        }
        this.isChanged = this.collectChanges().length > 0;
    };
    ProfileAgentController.prototype.enable = function (choice, option) {
        option.action = Action.Accept;
        if (option.kind === Kind.Placeholder) {
            return;
        }
        if (option.kind === Kind.Conflict) {
            this.findNestedRelatedChoices(choice).forEach(function (choice) {
                for (var _i = 0, _a = choice.options; _i < _a.length; _i++) {
                    var option_1 = _a[_i];
                    switch (option_1.kind) {
                        case Kind.Confirmed:
                        case Kind.Unconfirmed:
                        case Kind.Conflict:
                            option_1.action = Action.Reject;
                            break;
                        case Kind.Placeholder:
                            option_1.action = Action.Accept;
                            break;
                    }
                }
            });
        }
        this.findParentRelatedChoices(choice).forEach(function (choice) {
            if (choice.options.some(function (item) { return item.kind === Kind.Conflict && item.action === Action.Accept; })) {
                for (var _i = 0, _a = choice.options; _i < _a.length; _i++) {
                    var option_2 = _a[_i];
                    option_2.action = Action.Undecided;
                }
            }
        });
    };
    ProfileAgentController.prototype.findParentRelatedChoices = function (choice) {
        return this.choices
            .filter(function (item) { return item !== choice; })
            .filter(function (item) {
            return !item.filter.region ||
                (item.filter.region === choice.filter.region && !item.filter.country);
        });
    };
    ProfileAgentController.prototype.findNestedRelatedChoices = function (choice) {
        return this.choices
            .filter(function (item) { return item !== choice; })
            .filter(function (item) { return _.isMatch(item.filter, choice.filter); });
    };
    ProfileAgentController.prototype.collectChanges = function () {
        var options = _.flatten(this.choices.map(function (item) { return item.options; }));
        var changes = options.map(function (option) {
            if (option.action === Action.Accept) {
                switch (option.kind) {
                    case Kind.Conflict:
                        return [
                            {
                                kind: 'conflict-accept',
                                conflict: { _id: option.conflict._id },
                            },
                        ];
                    case Kind.Unconfirmed:
                        return [
                            {
                                kind: 'confirm',
                                representation: { _id: option.representations[0]._id },
                            },
                        ];
                    case Kind.Confirmed:
                    case Kind.Placeholder:
                        return null;
                }
            }
            if (option.action === Action.Reject) {
                switch (option.kind) {
                    case Kind.Conflict:
                        return [
                            {
                                kind: 'conflict-reject',
                                conflict: { _id: option.conflict._id },
                            },
                        ];
                    case Kind.Unconfirmed:
                    case Kind.Confirmed:
                        return option.representations.map(function (item) { return ({
                            kind: 'remove',
                            representation: { _id: item._id },
                        }); });
                    case Kind.Placeholder:
                        return null;
                }
            }
        });
        return _.flatten(changes).filter(function (item) { return !!item; });
    };
    ProfileAgentController.prototype.confirm = function () {
        var _this = this;
        var changes = this.collectChanges();
        this.promise = this.$representationService.applyChangesBulk(changes);
        this.promise.then(function () {
            _this.$userService.fetchUser().then(function (user) {
                _this.recalculateChoices(user);
                _this.isChanged = false;
            });
            _this.fetch();
        });
    };
    ProfileAgentController.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var representations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        representations = this.$representationService.queryPlayerRerepresentation(this.activeProfile.profile._id);
                        return [4, representations.$promise];
                    case 1:
                        _a.sent();
                        this.representations = representations;
                        this.tree = this.$representationService.createRepresentationTree(this.representations);
                        return [2];
                }
            });
        });
    };
    return ProfileAgentController;
}());
angular.module('app.profile').component('profileAgent', {
    templateUrl: 'profile/components/agent.html',
    controller: ProfileAgentController,
    bindings: {
        activeProfile: '<',
        editable: '<',
        editableForm: '<',
    },
});
;